<template>
  <div class="wrapper_login">
      <div class="margin">
      	 <div v-if='haslogin'>
	      	 <router-link to="/recharge" class="a">充值</router-link>
	      	 <router-link to="/reg" class="a">注册</router-link>
	      	 <router-link to="/login" class="a">登录</router-link>
      	 </div>
      	 <div v-else>
					 <div class="out_wrapper"><img  class="photo" src="../../images/yh_img_photo.png"/><label>{{nicname}}</label><span class="loginout" @click="loginout"><i class="icon_out"></i>退出</span></div>
				 </div>
      </div>
  </div>
</template>

<script>
export default {
	data(){
		return{
			haslogin:true,
			nicname:''
		}
	},
	mounted:function(){
		var nicname=sessionStorage.getItem('nickname');
		if(nicname&&nicname!=""){
			this.nicname=nicname;
			this.haslogin=false;
		}
	},
	methods:{
		loginout:function(){
				sessionStorage.removeItem('nickname');		
				let url=this.$route.path;
				if(url=='/home'){
					window.location.reload();
				}
				this.$router.push({name:'home'});
		}
	}
}

</script>

<style lang="scss" scoped>
	 @import '../../components/style/mixin';
	.wrapper_login {
	  width:100%;
	  height:100%;
	  border-bottom:1px solid #e6e6e6;
	  background-color:#f1efef;
	  .margin{
	  	text-align: right;	  	
	  	 .a{
	  	 		line-height: 35px;
	  	 		padding:0 22px;
	  	 		border-right:1px solid #d9d9d9;
	  	 		@include sc(14px, #666);
	  	 }
	  	 .a:last-child{
	  	 	border-right:0px;
	  	 }
	  	 .a:hover{
	  	 	color:#ffbb17;
	  	 }
	  }
	}
	    .out_wrapper{
				font-size:14px;
				line-height:34px;
				text-align: right;
			}
			 .out_wrapper .photo{
				display: inline-block;
				width:20px;
				height:20px;
				border-radius:50%;
				overflow: hidden;
				vertical-align: middle;
				margin-right:5px;
			}
			 .out_wrapper .loginout{
				display: inline-block;
				width:65px;
				/*height:24px;*/
				line-height:24px;
				border:1px solid #c7c7c7;
				border-radius:15px;
				text-align: center;
				font-size: 12px;
				margin-left:20px;	
				cursor: pointer;		
			}
			 .out_wrapper .loginout .icon_out{
				display:inline-block;
				width:12px;
				height:15px;
				background: url(../../images/yh_icon_out.png) no-repeat;
				vertical-align: middle;	
				margin-right:5px;					
			}
</style>
